import { ActionTypes } from './action-types';

export const setUser = user => ({
  type: ActionTypes.LEXON_USER,
  payload: user
});

export const setIdResponsable = idResonsable => ({
  type: ActionTypes.SET_ID_RESPONSABLE,
  payload: idResonsable
});


export const setAccount = account => ({
  type: ActionTypes.LEXON_ACCOUNT,
  payload: account
});

export const setCaseFile = casefile => ({
  type: ActionTypes.LEXON_CASEFILE,
  payload: casefile
});

export const setDataBase = database => ({
  type: ActionTypes.LEXON_DATABASE,
  payload: database
});

export const setIdEmail = emailInfo => ({
  type: ActionTypes.LEXON_EMAIL,
  payload: emailInfo
});

export const setEmailShown = flag => ({
  type: ActionTypes.LEXON_EMAIL_SET_SHOWN,
  payload: flag
});

export const resetIdEmail = emailInfo => ({
  type: ActionTypes.LEXON_RESET_EMAIL,
  payload: emailInfo
});

export const setMailContacts = mailContacts => ({
  type: ActionTypes.LEXON_MAILCONTACTS,
  payload: mailContacts
});

export const setDocumentsId = documentsId => ({
  type: ActionTypes.LEXON_DOCUMENTS_ID,
  payload: documentsId
});

export const setGUID = guid => ({
  type: ActionTypes.LEXON_ACCOUNT_GUID,
  payload: guid
});

export const setSign = sign => ({
  type: ActionTypes.LEXON_ACCOUNT_SIGN,
  payload: sign
});

export const setFirmas = firmas => ({
  type: ActionTypes.LEXON_ACCOUNT_FIRMAS,
  payload: firmas
});

export const setEmailTemplates = templates => ({
  type: ActionTypes.LEXON_ACCOUNT_TEMPLATES,
  payload: templates
});

export const setUserFolders = folders => ({
  type: ActionTypes.LEXON_ACCOUNT_FOLDERS,
  payload: folders
});

export const setIdMail = idMail => ({
  type: ActionTypes.LEXON_IDMAIL,
  payload: idMail
});

export const setToken = token => ({
  type: ActionTypes.LEXON_TOKEN,
  payload: token
});

export const setLexonTokenWithoutDocument = tokenWithoutDocument => ({
  type: ActionTypes.TOKEN_WITHOUT_DOCUMENT,
  payload: tokenWithoutDocument
});

export const setLexonToken = lexonToken => ({
  type: ActionTypes.TOKEN,
  payload: lexonToken
});

export const setIdActuation = idActuation => ({
  type: ActionTypes.LEXON_IDACTUATION,
  payload: idActuation
});

export const setIdEvent = idEvent => ({
  type: ActionTypes.LEXON_IDEVENT,
  payload: idEvent
});

export const setAppConnect = appConnect => ({
  type: ActionTypes.LEXON_APP_CONNECT,
  payload: appConnect
});

export const setIdCalendar = idCalendar => ({
  type: ActionTypes.LEXON_IDCALENDAR,
  payload: idCalendar
});

export const setNewIdActuation = idActuation => ({
  type: ActionTypes.LEXON_NEW_IDACTUATION,
  payload: idActuation
});

export const setNewIdEvent = idEvent => ({
  type: ActionTypes.LEXON_NEW_IDEVENT,
  payload: idEvent
});

export const setTitle = title => ({
  type: ActionTypes.LEXON_TITLE,
  payload: title
});

export const resetIdActuation = () => ({
  type: ActionTypes.LEXON_RESET_IDACTUATION
});

export const resetIdEvent = () => ({
  type: ActionTypes.LEXON_RESET_IDEVENT
});

export const setIsFirstLoad = value => ({
  type: ActionTypes.LEXON_FIRST_LOAD,
  payload: value
});

export const setIdClientLef = value => ({
  type: ActionTypes.LEXON_ID_CLIENT_LEF,
  payload: value
});

export const setConfigCalendar = config => ({
  type: ActionTypes.LEXON_CONFIG_CALENDAR,
  payload: config
});

export const lexonCredentialsClear = () => ({type: ActionTypes.LEXON_CREDENTIALS_CLEAR});

export const setCustomerConnectEmail = customerConnectEmail => ({
  type: ActionTypes.APPLICATION_CUSTOMER_CONNECT_EMAIL,
  payload: customerConnectEmail
});

export const setInterveners = interveners => ({
  type: ActionTypes.LEXON_INTERVENERS,
  payload: interveners
});

export const setSubjectEmail = subjectEmail => ({
  type: ActionTypes.LEXON_SUBJECT_EMAIL,
  payload: subjectEmail
});

export const setIsCompose = isCompose => ({
  type: ActionTypes.LEXON_IS_COMPOSE,
  payload: isCompose
});

export const setNextcloudAccountAuth = basicAuthToken => ({
  type: ActionTypes.NEXTCLOUD_ACCOUNT_AUTH,
  payload: basicAuthToken
});

export default {
  setUser,
  setDataBase,
  setIdEmail,
  setEmailShown,
  setAccount,
  setCaseFile,
  resetIdEmail,
  setMailContacts,
  setGUID,
  setSign,
  setFirmas,
  setEmailTemplates,
  setIdMail,
  setToken,
  setLexonToken,
  setTitle,
  setIdEvent,
  setIdCalendar,
  setIdActuation,
  resetIdActuation,
  resetIdEvent,
  setIsFirstLoad,
  setIdClientLef,
  setConfigCalendar,
  setAppConnect,
  setIdResponsable,
  lexonCredentialsClear,
  setCustomerConnectEmail,
  setDocumentsId,
  setLexonTokenWithoutDocument,
  setInterveners,
  setSubjectEmail,
  setNextcloudAccountAuth,
  setIsCompose,
};
